import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  text = 'Carregando...',
  className = ''
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className={`animate-spin rounded-full border-2 border-gray-300 dark:border-gray-700 border-t-[#2563eb] ${sizeClasses[size]}`}></div>
      {text && (
        <p className="mt-2 text-sm text-[#5b6b82] dark:text-muted">{text}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
